import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable, of } from 'rxjs';
import { IUserInfoCognito } from 'src/app/shared/services/cognito.service';
import { environment } from 'src/environments/environment';
import { OfferType } from '../models/offer-type';
import { getHeaders } from 'src/app/shared/utils/httpUtils';


@Injectable({
  providedIn: 'root'
})
export class OfertasEndpointService {

  constructor(private _http: HttpClient, private store: Store) { }
  
  public getVerticalList(userInfo: IUserInfoCognito | null, idOrganizacion: string | null): Observable<any> {
    if(!userInfo || !idOrganizacion) return of({})
    const idUsuario = userInfo.username;
    
    const headers = getHeaders(idOrganizacion, idUsuario, 'WEB');

    // Create HttpParams object to hold query parameters
    let params = new HttpParams()
      .set('idUsuario', idUsuario)
      .set('idOrganizacion', idOrganizacion)
      .set('requestOrigin', 'WEB');

    // Make the HTTP GET request with the parameters
    return this._http.get<any>(`${environment.backend.main}/OfertasFinancieras/listarVerticales`, { params: params, headers: headers });
  }

  public selectVerticalList(userInfo: IUserInfoCognito | null, idOrganizacion: string | null, offerTypes: OfferType[]) {
    if(!userInfo || !idOrganizacion) return of({})
    const idUsuario = userInfo.username;
    
    const headers = getHeaders(idOrganizacion, idUsuario, 'WEB');

    // Create HttpParams object to hold query parameters
    let params = new HttpParams()
      .set('idUsuario', idUsuario)
      .set('idOrganizacion', idOrganizacion)
      .set('requestOrigin', 'WEB');

    const body = {
      idUsuario: idUsuario,
      idOrganizacion: idOrganizacion,
      requestOrigin: 'WEB',
      configuracion: {
        verticalesFinancieras: offerTypes
      }
    }
    
    return this._http.post<any>(`${environment.backend.main}/OfertasFinancieras/seleccionarVerticales`, body, { params: params, headers: headers });
  }

  public listarOfertas(userInfo: IUserInfoCognito | null, idOrganizacion: string | null) {
    if(!userInfo || !idOrganizacion) return of({})
    const idUsuario = userInfo.username;
    
    const headers = getHeaders(idOrganizacion, idUsuario, 'WEB');

    // Create HttpParams object to hold query parameters
    let params = new HttpParams()
      .set('idUsuario', idUsuario)
      .set('idOrganizacion', idOrganizacion)
      .set('requestOrigin', 'WEB');

      // Make the HTTP GET request with the parameters
    return this._http.get<any>(`${environment.backend.main}/OfertasFinancieras/listarOfertas`, { params: params, headers: headers });
  }

  obtenerContratoVerticales(userInfo: IUserInfoCognito | null, idOrganizacion: string | null) {
    if(!userInfo || !idOrganizacion) return of({})
    const idUsuario = userInfo.username;
    
    const headers = getHeaders(idOrganizacion, idUsuario, 'WEB');

    // Create HttpParams object to hold query parameters
    let params = new HttpParams()
      .set('idUsuario', idUsuario)
      .set('idOrganizacion', idOrganizacion)
      .set('requestOrigin', 'WEB');

    // Make the HTTP GET request with the parameters
    return this._http.get<any>(`${environment.backend.main}/OfertasFinancieras/obtenerContratoVerticales`, { params: params, headers: headers });
  }

  public detalleOferta(userInfo: IUserInfoCognito | null, idOrganizacion: string | null, idOferta: number, idOrganizacionCliente: string) {
    if(!userInfo || !idOrganizacion) return of({})
    const idUsuario = userInfo.username;
    
    const headers = getHeaders(idOrganizacion, idUsuario, 'WEB');

    // Create HttpParams object to hold query parameters
    let params = new HttpParams()
      .set('idUsuario', idUsuario)
      .set('idOrganizacion', idOrganizacion)
      .set('requestOrigin', 'WEB')
      .set('idOferta', idOferta)
      .set('idOrganizacionCliente', idOrganizacionCliente);

    // Make the HTTP GET request with the parameters
    return this._http.get<any>(`${environment.backend.main}/OfertasFinancieras/obtenerOferta`, { params: params, headers: headers });
  }

  public contactarEjecutivo(
      userInfo: IUserInfoCognito | null, 
      idOrganizacionUsuario: string | null, 
      idOrganizacionCliente: string |undefined, 
      idVertical: string | undefined, 
      nombreVertical: string, 
      idOferta: string, 
      plazoOferta: number |undefined, 
      montoOferta: string | any) {
    console.log(userInfo, idOrganizacionCliente, idOrganizacionUsuario, idVertical)
    if(!userInfo || !idOrganizacionUsuario || !idOrganizacionCliente || !idVertical) return of({ error: true })
    const idUsuario = userInfo.username;
    
    const headers = getHeaders(idOrganizacionUsuario, idUsuario, 'WEB');

    // Create HttpParams object to hold query parameters
    let params = new HttpParams()
      .set('idUsuario', idUsuario)
      .set('idOrganizacion', idOrganizacionUsuario)
      .set('requestOrigin', 'WEB');

    const body = {
      idUsuario: idUsuario,
      idOrganizacion: idOrganizacionUsuario,
      idOrganizacionUsuario: idOrganizacionUsuario,
      idOrganizacionCliente: idOrganizacionCliente,
      idVertical: idVertical,
      idOferta: idOferta,
      mailUsuario: userInfo.email,
      nombreUsuario: userInfo.given_name,
      nombreVertical: nombreVertical,
      plazoOferta: plazoOferta,
      montoOferta: montoOferta,//TESST - CAMBIAR
      requestOrigin: 'WEB',
    }
    
    return this._http.post<any>(`${environment.backend.main}/OfertasFinancieras/contactarEjecutivo`, body, { params: params, headers: headers });
  }

  public getOfferCount(userInfo: IUserInfoCognito | null, idOrganizacion: string | null) {
    if(!userInfo || !idOrganizacion) return of({ error: true })
    const idUsuario = userInfo.username;
    
    const headers = getHeaders(idOrganizacion, idUsuario, 'WEB');

    // Create HttpParams object to hold query parameters
    let params = new HttpParams()
      .set('idUsuario', idUsuario)
      .set('idOrganizacion', idOrganizacion)
      .set('requestOrigin', 'WEB');

      // Make the HTTP GET request with the parameters
    return this._http.get<any>(`${environment.backend.main}/OfertasFinancieras/contarOfertas`, { params: params, headers: headers });
}
}
